 /*
创建者 魏强(2018.1.29)
*/
<template>
    <div class="module-mid">
        <div class="swipe-wrap">
            <list-ad :data="middleUpAdv.advList"></list-ad>
            <list-ad :data="middleDownAdv.advList"></list-ad>
        </div>
    </div>
</template>
<script>
    import listAd  from './list.vue';
    export default{
        props:["middleUpAdv","middleDownAdv"],
        components:{
            listAd
        },
        data(){
            return {}
        }
    }
</script>



// WEBPACK FOOTER //
// index.vue?149a2050